import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrillingRig: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrillingRig"><Path d="M15 11.1111L6.90909 21M9 11.1111L17.0909 21M8.5 10.5H15.5L17.5 21.5H6.5L8.5 10.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M13.7992 6.7C13.7992 7.69411 12.9933 8.5 11.9992 8.5C11.0051 8.5 10.1992 7.69411 10.1992 6.7C10.1992 4.9 11.3992 2.5 11.9992 2.5C12.5992 2.5 13.7992 4.9 13.7992 6.7Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 21.5H4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDrillingRig;
